const httpLib = require('./http-library.js');
const publicConfig = require('../public-config.js');
const ssoHost = publicConfig.external_address;

function _readMessages (path, accessToken, callback) {
  const request_params = {
    host: ssoHost,
    path,
    method: 'GET',
    headers: {
      Authorization: 'Bearer ' + accessToken
    }
  };
  httpLib.request(request_params, function (response) {
    callback(response);
  }, null);
}

function _createMessages (payload, token, callback) {
  const params = {
    host: ssoHost,
    method: 'POST',
    path: '/v1/message/send',
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json'
    }
  };
  httpLib.request(params, (res) => {
    callback(res);
  }, payload);
}

function _updateMessages (path, token, callback) {
  const params = {
    host: ssoHost,
    method: 'PUT',
    path: `/v1/message/update?${path}`,
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json'
    }
  };
  httpLib.request(params, (res) => {
    callback(res);
  });
}

function _readStreamToken (ssoId, token, callback) {
  const params = {
    host: ssoHost,
    method: 'GET',
    path: `/v1/messaging/stream/token/user?ssoid=${ssoId}`,
    headers: {
      Authorization: `Bearer ${token}`
    }
  };
  httpLib.request(params, function (res) {
    callback(res);
  });
}

function _uploadAttachment (streamChannelId, fileName, token, callback) {
  const params = {
    host: ssoHost,
    method: 'GET',
    path: `/v2/messaging/attachments/upload?stream_channel_id=${streamChannelId}&file_name=${fileName}`,
    headers: {
      Authorization: `Bearer ${token}`
    }
  };
  httpLib.request(params, function (res) {
    callback(res);
  });
}

function _uploadAttachmentCompleted (canonicalUrl, token, callback) {
  const payload = { canonical_url: canonicalUrl };
  const params = {
    host: ssoHost,
    method: 'POST',
    path: '/v2/messaging/attachments/upload/completed',
    headers: {
      Authorization: `Bearer ${token}`
    }
  };
  httpLib.request(params, function (res) {
    callback(res);
  }, payload);
}

function _refreshAttachments (payload, token, callback) {
  const params = {
    host: ssoHost,
    method: 'POST',
    path: '/v2/messaging/update-asset-urls',
    headers: {
      Authorization: `Bearer ${token}`
    }
  };
  httpLib.request(params, function (res) {
    callback(res);
  }, payload);
}

const Messages = {

  /**
   * @function
   * @name readMessages
   * @param {String}   - Path String
   * @param {String}   - Access token (retrived from sessions)
   * @param {Function} - Callback
   */

  read: (path, token, callback) => {
    const readMessages = _readMessages(path, token, callback);
    return readMessages;
  },

  /**
   * @function
   * @name getMessages
   * @param {Object}   - Payload
   * @param {String}   - Access token (retrived from sessions)
   * @param {Function} - Callback
   */
  create: (payload, token, callback) => {
    const createMessages = _createMessages(payload, token, callback);
    return createMessages;
  },

  /**
   * @function
   * @name getMessages
   * @param {String}   - Path
   * @param {String}   - Access token (retrived from sessions)
   * @param {Function} - Callback
   */
  update: (path, token, callback) => {
    const updateMessages = _updateMessages(path, token, callback);
    return updateMessages;
  },

  readStreamToken: (ssoId, token, callback) => {
    const readStreamTokenAction = _readStreamToken(ssoId, token, callback);
    return readStreamTokenAction;
  },

  uploadAttachment: (streamChannelId, fileName, token, callback) => {
    const readStreamTokenAction = _uploadAttachment(streamChannelId, fileName, token, callback);
    return readStreamTokenAction;
  },

  uploadAttachmentCompleted: (canonicalUrl, token, callback) => {
    const readStreamTokenAction = _uploadAttachmentCompleted(canonicalUrl, token, callback);
    return readStreamTokenAction;
  },

  refreshAttachments: (payload, token, callback) => {
    const readStreamTokenAction = _refreshAttachments(payload, token, callback);
    return readStreamTokenAction;
  }
};

exports.Messages = Messages;
